export const noPagination = {
  getNextPageParam: () => undefined,
  initialPageParam: undefined,
} as const;
